export default __webpack_public_path__ + "media/hero.f9eefbdef85e68b2b4e9b33d9601a453.svg";